<div class="top-header">
  <span class="logo">TRAFO - Stevanovic</span>

  <div class="user-options">
    <span> {{ curentUser.user.username }} - {{ [curentUser.user.fname +" "+ curentUser.user.lname ]}} </span>
    <div class="user-img"><i class="pi pi-user"></i></div>
    <div class="user-option-dropdown">
      <button class="main-btn" (click)="onLogout()" >Odjavi se <i class="pi pi-sign-out"></i> </button>
    </div>

  </div>
</div>
